import type { ReactNode } from 'react'
import { cx } from '../../cx'

export interface CardProps {
  eyebrow?: ReactNode
  title?: ReactNode
  footer?: ReactNode
  className?: string
  children?: ReactNode
  /** Heading level for `title`. Default 3. Pick the one that fits the page outline. */
  titleAs?: 'h2' | 'h3' | 'h4'
}

/**
 * Presentational, so there is no behavior to borrow from React Aria — but the
 * title still renders as a real heading rather than a styled <div>, so screen
 * reader users can navigate by heading.
 */
export function Card({
  eyebrow,
  title,
  footer,
  className,
  children,
  titleAs: Heading = 'h3',
}: CardProps) {
  return (
    <section className={cx('bui-card', className)}>
      {eyebrow ? <div className="bui-card-eyebrow">{eyebrow}</div> : null}
      {title ? <Heading className="bui-card-title">{title}</Heading> : null}
      {children ? <div className="bui-card-body">{children}</div> : null}
      {footer ? <div className="bui-card-foot">{footer}</div> : null}
    </section>
  )
}
